import React from 'react';
import { useStore } from '../../context/StoreContext';
import StoreNotFoundPage from '../../pages/common/StoreNotFoundPage';
import PageLoadingSpinner from '../common/PageLoadingSpinner';

const StoreNotFoundGuard = ({ children }) => {
  const { notFound, loading, subdomainMode, storeId } = useStore();

  if (notFound) {
    return <StoreNotFoundPage />;
  }

  if (subdomainMode && loading && !storeId) {
    return <PageLoadingSpinner />;
  }

  return children;
};

export default StoreNotFoundGuard;
